var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('order-deliveries-commitment-list',{attrs:{"order-id":_vm.orderId,"router-from-order":true,"readonly":_vm.readonly,"can-remove":_vm.canRemove},on:{"ready":function($event){return _vm.syncLoad.ready('delivery')}}})}
var staticRenderFns = []

export { render, staticRenderFns }